import React from "react";

import Header from "./Header";
import Breadcrumb from "./Breadcrumb";
import MainContainer from "./Layout/MainContainer";
import SidebarMais from "./SidebarMais";
import ControleProducaoBaseSemanalAlertBanner from "./ControleProducao/BaseSemanalAlertBanner";
import { HeaderProvider } from "./Header/context/HeaderContext";

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
}

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({
  children,
}) => {
  return (
    <HeaderProvider>
      <MainContainer>
        <Header />
        <ControleProducaoBaseSemanalAlertBanner />
        <div className="flex min-w-0">
          <SidebarMais />
          <div className="min-w-0 flex-1 overflow-x-hidden">
            <Breadcrumb />
            <main>{children}</main>
          </div>
        </div>
      </MainContainer>
    </HeaderProvider>
  );
};

export default AuthenticatedLayout;
